export const STAGE =
  window.location.hostname === "stageapp.eadstock.com.br" ? "stage" : "";
export const KEYCLOAK_REALM = "eadstock";
export const CLIENT_ID = `${STAGE}eadstockwebapp`;
//ROLES MESTRE"
export const ROLE_SUPERUSER = "superuser";
export const ROLE_SUPER_ADMIN_ORGANIZATION = "superadmin-organization";
export const ROLE_CLIENT = "eadstock-client";
export const ROLE_PARTNER = "eadstock-partner";
export const GROUP_SUPERUSER = "/eadstock-b42";
//ROLES POR FUNÇÃO
export const ROLE_SOLICITAR_CATALOGOS = "catalogos.solicitar";
export const ROLE_VER_CATALOGOS = "catalogos.read";
export const ROLE_VER_ALUNOS_ATIVOS = "alunos-ativos.read";
export const ROLE_VER_DOCUMENTOS = "documentos.read";
export const ROLE_FINANCEIRO_VER_COBRANCAS = "financeiro.cobrancas.read";
export const ROLE_FINANCEIRO_VER_RELATORIOS = "financeiro.relatorios.read";
export const URL_SUPORTE = "https://portal.milvus.com.br/#/login";


export const ID_HOTJAR = STAGE == "stage" ? "3298783" : "3298781";

export const ID_PUSHER_PRODUCTION =
  STAGE == "stage" ? "c251dde1293ed84b154e" : "ca89196185425369351c";
export const CHANNEL_PUSHER_PRODUCTION =
  STAGE == "stage" ? "eadstock-app-staging" : "eadstock-app-production";

export const ID_PUSHER =
  process.env.NODE_ENV === "development"
    ? "354a0aa9cec84a87683d"
    : ID_PUSHER_PRODUCTION;
export const CHANNEL_PUSHER =
  process.env.NODE_ENV === "development"
    ? "eadstock-app-development"
    : CHANNEL_PUSHER_PRODUCTION;

export const PROTOCOL = window.location.protocol;
export const API_GAEL_URL = PROTOCOL + `//${STAGE}apigael.eadstock.com.br`;
export const API_ADMIN_URL = PROTOCOL + `//${STAGE}api.eadstock.com.br`;
export const ALICE_PROD_URL = PROTOCOL + `//${STAGE}alice.eadstock.com.br`;
export const ALICE_URL =
  process.env.NODE_ENV === "development"
    ? "http://127.0.0.1:3000"
    : ALICE_PROD_URL;

export const MY_ACCOUNT_REDIRECT_URL = PROTOCOL + "//myaccount.eadstock.com.br";
export const KEYCLOAK_AUTH_ROLE = "feature:authenticate";
//ToDo: Criar Lambda e Api gateway com CORS de http para ambiente de dev do preview e do contato
export const API_LANDING_EADSTOCK =
  process.env.NODE_ENV === "development"
    ? "https://t4bkhw4407.execute-api.us-east-1.amazonaws.com/Production-EadstockLandingPage"
    : "https://t4bkhw4407.execute-api.us-east-1.amazonaws.com/Production-EadstockLandingPage";

// export default { API_GAEL_URL, API_LANDING_EADSTOCK };

export const TIPO_DOC_CATEGORIA_CURSO = "C";
export const TIPO_DOC_CATEGORIA_DISCIPLINA = "D";
export const TIPO_DOC_CATEGORIA_AUTOR = "A";